import { colorPalette } from "@shared/config/colorsConfig";

export const HOME_CARD = {
    shadow: {
        shadowColor: '#0A2440',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.06,
        shadowRadius: 4,
        elevation: 1,
    },
    iconBox: 46,
    iconGlyph: 28,
} as const;

export const HOME_STEPS = {
    iconGlyph: 30,
    checkGlyph: 22,
    accent: colorPalette.secondary[600],
    reachedAccent: colorPalette.success[500],
    reachedTrack: colorPalette.success[100],
} as const;

export const HOME_READING = {
    rowPaddingY: 14,
    iconBox: 40,
    iconRadius: 11,
    iconGlyph: 22,
} as const;
